"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocaleSyncer = LocaleSyncer;

var _react = require("react");

var _reactRouterDom = require("react-router-dom");

var _useTranslate2 = require("./use-translate");

var _browserCookies = _interopRequireDefault(require("browser-cookies"));

var _qs = _interopRequireDefault(require("qs"));

var _excluded = ["locale"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Export `LocaleSyncer` container.
 */
function LocaleSyncer(_ref) {
  var domain = _ref.domain,
      languages = _ref.languages;

  var _useTranslate = (0, _useTranslate2.useTranslate)(),
      i18n = _useTranslate.i18n;

  var history = (0, _reactRouterDom.useHistory)();
  var location = (0, _reactRouterDom.useLocation)();
  (0, _react.useEffect)(function () {
    var cookieLocale = _browserCookies["default"].get('locale');

    if (cookieLocale !== i18n.language) {
      _browserCookies["default"].set('locale', i18n.language, {
        domain: domain
      });
    }
  }, [domain, i18n.language]);
  (0, _react.useEffect)(function () {
    var search = location.search,
        state = location.state;

    var queryParameters = _qs["default"].parse(search, {
      ignoreQueryPrefix: true
    });

    var locale = queryParameters.locale,
        restQuery = _objectWithoutProperties(queryParameters, _excluded);

    if (languages.length > 1) {
      if (i18n.language !== locale) {
        // Set the locale query param to match the app's language.
        history.replace({
          search: _qs["default"].stringify(_objectSpread(_objectSpread({}, restQuery), {}, {
            locale: i18n.language
          })),
          state: state
        });
      }
    } else if (locale) {
      // Remove the locale query param when there is only one language.
      history.replace({
        search: _qs["default"].stringify(restQuery),
        state: state
      });
    }
  }, [history, i18n.language, languages, location]);
  return null;
}